export const style = {
  list: {
    padding: 0,
    margin: 0,
    listStyle: `none`
  },
  listItemLink: {
    fontSize: `14px`,
    fontWeight: `400`,
    lineHeight: `30px`,
    textAlign: `center`,
    height: `30px`,
    width: `30px`,
    color: `#A94545`,
    textDecoration: `none`,
    ':hover': {
      background: `rgba(0, 0, 0, 0.1)`
    }
  },
  listItemLinkActive: {
    color: `#333`,
    pointerEvents: `none`,
    ':hover': {
      background: `none`
    }
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Pagination/style/list.js